import React from 'react';
import "./UsefulLinks.css";

const UsefulLinks = () => {
  return (
    <div className="useful-links">
        <div className="useful-links-title">
            <h5>Usefull Links</h5>
            <div></div>
        </div>
        <nav>
            <li><a href="#tournaments">Tournamets</a></li>
            <li><a href="">Help Center</a></li>
            <li><a href="#footer">Privacy And Policy</a></li>
            <li><a href="">Terms Of Use</a></li>
            <li><a href="#contact">Contact Us</a></li>
        </nav>
    </div>
  )
}

export default UsefulLinks